const DEFAULT_STATIC = '/cms/i3/site-content.json';

/** Base URL for public SQL-backed CMS (app-service). Empty if unset. */
export function getPortalPublicCmsBase(): string {
  return (process.env.REACT_APP_PORTAL_PUBLIC_CMS_BASE || '').trim().replace(/\/$/, '');
}

export function getI3PortalSiteSlug(): string {
  return (process.env.REACT_APP_I3_PORTAL_SLUG || 'i3-coaching').trim() || 'i3-coaching';
}

/** Full URL for GET /api/public/portal/sites/:slug/site-content, or null if SQL CMS disabled. */
export function getPublicPortalSiteContentUrl(): string | null {
  const base = getPortalPublicCmsBase();
  if (!base) return null;
  const slug = getI3PortalSiteSlug();
  return `${base}/api/public/portal/sites/${encodeURIComponent(slug)}/site-content`;
}

export function getStaticI3CmsUrl(): string {
  return (process.env.REACT_APP_I3_CMS_URL || DEFAULT_STATIC).trim() || DEFAULT_STATIC;
}
